import { render, staticRenderFns } from "./settlementOrder.vue?vue&type=template&id=508f9783"
import script from "./settlementOrder.vue?vue&type=script&lang=ts"
export * from "./settlementOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports